/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid number for the chosen base.`)
};

const es_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un número válido para la base elegida.`)
};

const de_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib eine gültige Zahl für die gewählte Basis ein.`)
};

const nl_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een geldig getal in voor de gekozen basis.`)
};

const fr_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un nombre valide pour la base choisie.`)
};

const it_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un numero valido per la base scelta.`)
};

const pt_br2_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um número válido para a base escolhida.`)
};

const pt_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um número válido para a base escolhida.`)
};

const ja_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したベースの有効な数値を入力してください。`)
};

const zh_nb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入符合所选进制的有效数字。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_invalid", locale)
	if (locale === "en") return en_nb_invalid(inputs)
	if (locale === "es") return es_nb_invalid(inputs)
	if (locale === "de") return de_nb_invalid(inputs)
	if (locale === "nl") return nl_nb_invalid(inputs)
	if (locale === "fr") return fr_nb_invalid(inputs)
	if (locale === "it") return it_nb_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_nb_invalid(inputs)
	if (locale === "pt") return pt_nb_invalid(inputs)
	if (locale === "ja") return ja_nb_invalid(inputs)
	return zh_nb_invalid(inputs)
};